/**
 * 物料／非庫存採購異動單狀態：DRAFT → SUBMITTED → APPROVED｜REJECTED。
 * `APPLIED` 為舊「立即套用」資料，唯讀顯示。同一採購單同時最多一張 DRAFT／SUBMITTED。
 */

export const PURCHASE_AMENDMENT_STATUS = {
  DRAFT: 'DRAFT',
  SUBMITTED: 'SUBMITTED',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
  APPLIED: 'APPLIED',
};

export const PURCHASE_AMENDMENT_STATUS_LABELS = {
  DRAFT: '草稿',
  SUBMITTED: '已提交',
  APPROVED: '已核准',
  REJECTED: '已退回',
  APPLIED: '已套用',
};

export function formatPurchaseAmendmentStatusLabel(status) {
  if (status == null || status === '') {
    return '—';
  }
  return PURCHASE_AMENDMENT_STATUS_LABELS[status] ?? status;
}

export function isOpenPurchaseAmendmentStatus(status) {
  return status === PURCHASE_AMENDMENT_STATUS.DRAFT
    || status === PURCHASE_AMENDMENT_STATUS.SUBMITTED;
}

export function findOpenPurchaseAmendment(amendments) {
  return (amendments ?? []).find((row) => isOpenPurchaseAmendmentStatus(row?.status))
    ?? null;
}

export function hasOpenPurchaseAmendment(amendments) {
  return Boolean(findOpenPurchaseAmendment(amendments));
}

export function isPurchaseAmendmentDraft(amendment) {
  return amendment?.status === PURCHASE_AMENDMENT_STATUS.DRAFT;
}

export function isPurchaseAmendmentSubmitted(amendment) {
  return amendment?.status === PURCHASE_AMENDMENT_STATUS.SUBMITTED;
}

export function pickPurchaseAmendmentUpdatedAt(amendment) {
  return amendment?.record?.updatedAt ?? amendment?.updatedAt ?? null;
}

/** 物料採購回應為扁平欄位；非庫存採購包在 `history`。兩者都讀。 */
export function pickPurchaseAmendmentHistory(amendment) {
  const history = amendment?.history ?? {};
  return {
    submittedAt: history.submittedAt ?? amendment?.submittedAt ?? null,
    approvedAt: history.approvedAt ?? amendment?.approvedAt ?? amendment?.appliedAt ?? null,
    rejectedAt: history.rejectedAt ?? amendment?.rejectedAt ?? null,
    rejectReason: history.rejectReason ?? amendment?.rejectReason ?? null,
  };
}

/** amendment_no DESC（後端已排；前端再排一次）。不改動原陣列。 */
export function sortPurchaseAmendmentsDesc(amendments) {
  return [...(amendments ?? [])].sort((left, right) => (
    String(right?.amendmentNo ?? '').localeCompare(
      String(left?.amendmentNo ?? ''),
      undefined,
      { numeric: true },
    )
  ));
}
